import { Theme02Static } from "components";
import { Theme02 } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.THEME02.path,
      name: "Theme02",
      key: routesMap.THEME02.path,
      commonRoute: false,
      private: true,
      adminAccess: true,
      belongsToSidebar: false,
      element: <Theme02Static />,
    },
    {
      path: `${routesMap.THEME02.path}/:id`,
      name: "Theme02",
      key: `${routesMap.THEME02.path}/:id`,
      commonRoute: true,
      private: true,
      adminAccess: true,
      belongsToSidebar: false,
      element: <Theme02 />,
    },
  ];
}
